"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMobileOs = void 0;
var _react = require("react");
var _uaParserJs = require("ua-parser-js");
const useMobileOs = () => {
  const [userOs, setUserOs] = (0, _react.useState)(null);
  (0, _react.useEffect)(() => {
    const parse = new _uaParserJs.UAParser();
    const os = parse.getOS();
    if (os.name === 'Android') {
      setUserOs(os.name);
    } else if (os.name === 'iOS') {
      setUserOs('Ios');
    }
  }, []);
  return {
    userOs
  };
};
exports.useMobileOs = useMobileOs;